import { auth0ApiClient } from './auth0ApiClient'
import type { ReactionType } from '@/types/feed'

class CuratedItemReactionService {
  private readonly baseUrl = '/feed/curated'

  upsertReaction(curatedItemId: string, type: ReactionType): Promise<void> {
    return auth0ApiClient.post<void>(`${this.baseUrl}/${curatedItemId}/reactions`, { type })
  }

  removeReaction(curatedItemId: string): Promise<void> {
    return auth0ApiClient.delete<void>(`${this.baseUrl}/${curatedItemId}/reactions`)
  }
}

export const curatedItemReactionService = new CuratedItemReactionService()
